import { Theme } from "@amx/ux-twoui-theming";
import { IStackStyles } from "@fluentui/react";

export const getStyles = (index: number, theme: Theme): IStackStyles => {
    const paddingLeft = ["12px", "7px", "15px"];
    return {
        root: {
            width: "100%",
            paddingLeft: paddingLeft[index],
            cursor: "pointer",
            marginLeft: "-14px",
            selectors: {
                ":hover": {
                    backgroundColor: theme.palette.neutralLighterAlt,
                },
                ":active": {
                    backgroundColor: theme.palette.neutralLight,
                }
            }
        }
    };
};

export const getMenuItemStyles = (theme: Theme): IStackStyles => ({
    root: {
        width: "100%",
        height: "100%",
        paddingLeft: "9px",
        cursor: "pointer",
        backgroundColor: theme.palette.neutralHigh,
        selectors: {
            ":hover": {
                backgroundColor: theme.palette.neutralLighterAlt,
            },
            ":active": {
                backgroundColor: theme.palette.neutralLight,
            }
        }
    }
});
